import { type ItemInfo, MENU_LABEL } from '@core/models/navigation-item.model';

export function isUpgradeRequired(item: ItemInfo): boolean {
  return item.payment && item?.menuLabel !== MENU_LABEL.PREMIUM;
}

export function isAllSubItemsRequireUpgrade(item: ItemInfo[]): boolean {
  return item.every((subItem) => subItem.payment);
}
